<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title txt-black">Preguntas Frecuentes</h1>

    <h6>1.-¿Cómo Funciona el Negocio FeRos dD?</h6>
    <p>
      Somos una Empresa de 2 Matrices [2 TABLAS] UniLevel sin limite de Directos.
    </p>
    <p>
      Con 2 Niveles la TABLA1 Y con 2 Niveles + 1 Nivel ADICIONAL la TABLA2.
    </p>
    <p>
      Que logra el pago/reparto entre sus Afiliados del 55.5% [$1,500] de Ganancias del total de Pedido Mínimo de C/Afiliado [$2,700 A CREDITO O DE CONTADO] tanto de Bono de Afiliación [$1,500 al Dia Siguiente o Semana Sig] como de Pagos de Regalías [$1,500 al mes Sig distribuidos en los Sig. Niveles], Pagando las Siguientes Cantidades por Nivel:
    </p>
    <div class="mt-3 table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th></th>
            <th class="f-w-600">
              TABLA1 [Cantidad($MXN)/Regalías]
            </th>
            <th  class="f-w-600">
              TABLA2 [Cantidad($MXN)/Regalías]
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th  class="f-w-600">NIVEL 1</th>
            <td>$1,000</td>
            <td>$200</td>
          </tr>
          <tr>
            <th  class="f-w-600">NIVEL 2</th>
            <td>$500</td>
            <td>$300</td>
          </tr>
          <tr>
            <th  class="f-w-600">NIVEL 3</th>
            <td>$0</td>
            <td>$1,000</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <h6>2.-¿Qué es la COMPRESIÓN ANTICIPADA de FeRos dD?</h6>
    <p>
      Es Nuestra Ventaja como Empresa que hace posible pagarle a los afiliados más rápido y mayor cantidad de dinero gracias a AUMENTAR EL PORCENTAJE DE GANANCIA POR NIVEL GRACIAS A TENER SOLO 2 NIVELES + 1PLUS.
    </p>

    <br />
    <h6>3.-¿Cuántos Niveles de Cobro para cada Afiliado tiene la Empresa?</h6>
    <p>
      2 Niveles en TABLA1 [Capitaliza-T] y<br />
      3 Niveles en TABLA2 [Turbo]
    </p>

    <br />
    <h6>4.-¿Qué Porcentaje de Ganancia otorga la Empresa?</h6>
    <p>
      El 55.5 % [menos una pequeña porción de Impuesto]
    </p>

    <br />
    <h6>5.-¿Qué Cantidad de Puntos y/o Volumen Grupal/Individual es Necesario para Acceder a Pagos?</h6>
    <p>
      CERO PUNTOS, CERO VOLUMEN …No es Obligatorio Vender, el pago no está condicionado a ello si no al autoConsumo.
    </p>
    <p>
      Aún así VENDER resulta ser UN GRAN RECURSO PARA GANANCIAS DE HASTA EL 200% y hasta mas del 500% en una circunstancia especifica.
    </p>
    <p>
      Además <strong>¡TAMPOCO TENEMOS RANGOS!</strong>
    </p>

    <br />
    <h6>6.-¿Cada cuándo paga la Empresa?</h6>
    <p>
      Las Afiliaciones AL DIA SIGUIENTE O SEMANA SIGUIENTE.<br />
      Las Regalías +-A MITAD DEL MES SIGUIENTE.
    </p>

    <br />
    <h6>7.-¿Porqué se dice que FeRos dD paga 10 VECES MAS DINERO CON 10 VECES MENOS PERSONAS?</h6>
    <p>
      Porque la Empresa te paga Mucho en el Nivel 1 y Mucho en Total en Nuestros 2(+1) Niveles. En Comparación a la normalidad en otras Empresas que pagan talvez muy poco en Nivel 1 y dispersan bastante el total de pago en un exceso de Niveles.
    </p>

    <br />
    <h6>8.-¿El envío esta incluido?</h6>
    <p>
      Si. (Solo si solo se pide la cantidad fijada de reCompra que incluye 17 Productos por $2,700), en caso de pedir producto adicional existirá cobro de paquetería variable dependiendo Kilogramos Totales y/o Dimensiones del Paquete bajo tabulaciones predefinidas en el Software de Paquetería de la Empresa.
    </p>

    <br />
    <h6>9.-Cuál es la Cantidad mínima de pedido que se debe realizar cada mes?</h6>
    <p>
      17 Productos por $2,700 (C/1 de estos 17 Productos son 1 Sobre de 30 Capsulas) …en esta modalidad inicial de Pedido a sea de Afiliación o Recompra SE PUEDEN ELEGIR SOLO PRODUCTOS ESTANDAR, Siempre se pide primero 17 Estándar después ADICIONALES QUE RESULTAN SER OPCIONALES… (Entre los cuales pueden elegirse MAS PRODUCTO ESTANDAR, PRODUCTOS PLUS Y a precios AFILIADO O A PRECIOS DE PROMO VIGENTE)
    </p>

    <br />
    <h6>10.-¿La Membresía es Vitalicia?</h6>
    <p>
      No, La Membresía tiene una Vigencia de 6 Meses posteriores a la Afiliación. Se recomienda activarse con reCompra los 1eros días de c/mes para Acceder a los pagos DÍA SIGUIENTE.
    </p>

    <br />
    <h6>11.-¿Cuántos Productos tiene la Empresa?</h6>
    <p>
      22 Productos.<br />
      (17 Estándar, y 5 Productos Plus), cada producto recomendado para 1 Mes.<br />
    </p>
    <p class="mt-2">
      La Gran Mayoría de los Productos son Sobres de 30 Capsulas.<br />
      Solo un sobre tiene 4 Capsulas, otro mas tiene 45 Caps.
    </p>
    <p>
      Y Solo un Producto tiene Presentación diferente a Capsulas. (Se trata de un paquete de 30 SOBRES DE 15 GRAMOS de JUGO VERDE DESHIDRATADO DE +27 Ingredientes)
    </p>

    <br />
    <h6>12.-¿Porqué se hace llamar FeRos dD “Una Empresa Generosa y Atípica”?</h6>
    <p>
      Porque FeRos paga mucho y con 100% de Conveniencia para el Afiliado, lo cual no es normal.
    </p>

    <br />
    <h6>13.-¿Qué Significa FeRos dD [FeRos DinaFlex Diamante]?</h6>
    <p>
      FeRos: Es la Fusión del Nombre del Fundador de la Empresa Fernando Pacheco y su Esposa Rosy!
    </p>
    <p>
      dD: Es porque nuestro Proyecto tiene un PLAN DE PAGOS DINAMICO FLEXIBLE y porque al inscribirte en nuestra empresa debutas (a falta de rangos) con un ROL Y POTENCIAL de rango DIAMANTE.
    </p>

    <br />
    <h6>14.-¿Cómo son los Productos de FeRos dD?</h6>
    <p>
      Son sobres de 30 Capsulas y sobres de Polvo Deshidratado de Mezclas Sinérgicas de Herbolaria 100% Natural.
    </p>

    <br />
    <h6>15.-¿Cuántos años de Existencia tiene La Empresa?</h6>
    <p>
      La Empresa Existe desde el Año 2007. Los últimos años afianzando la logística para transicionar de ser una Empresa Nacional Punto de Venta Directa por sus propios medios a ser una empresa con esquema de afiliación de RED DE MERCADEO.
    </p>
  </div>
</template>

<script>
export default {
}
</script>
